import { render, staticRenderFns } from "./AsignarAvlsModal.vue?vue&type=template&id=bf239296&scoped=true"
import script from "./AsignarAvlsModal.vue?vue&type=script&lang=js"
export * from "./AsignarAvlsModal.vue?vue&type=script&lang=js"
import style0 from "./AsignarAvlsModal.vue?vue&type=style&index=0&id=bf239296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf239296",
  null
  
)

export default component.exports